import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useConditionalVisibility } from '../../../_hooks/useConditionalVisibility';
const CustomTextField = ({ question }) => {
  const { label,isHidden, size = "small",disable, fieldId, rules,defaultValue='' ,dependantConditions={conditions : [], operator:"AND"}} = question;
  const {control, formState: { errors }} = useFormContext();  

 const isVisible = useConditionalVisibility(dependantConditions );
  if (!isVisible && isHidden) return null;

  return (
    <Controller
      name={fieldId}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          label={label}
          error={!!errors[fieldId]}
          helperText={errors[fieldId]?.message}
          disabled={disable}
          size={size}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};

export default CustomTextField;
